<template>
  <button
    class="flex w-full items-center gap-2 p-2 text-sm transition-colors hover:bg-gray-100"
    @click="$emit('click')"
  >
    <slot name="icon">
      <i-heroicons-trash class="inline-block h-6 w-6" />
    </slot>
    <span class="whitespace-nowrap first-letter:capitalize">
      <slot />
    </span>
  </button>
</template>

<script lang="ts" setup>
defineEmits<{ click: [] }>();
</script>
